import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import type { SelectOption } from '@swf/components/Inputs/components/DropDown/DropDown';
import type { TableParams } from '@swf/generated/types/api/v0/SwHomeGames';
import { PotTypeTranslations } from '@swf/poker';

import { fallback } from '../utils/common';

const useGetGameType = (gameData: TableParams[], handTypeValue: string): SelectOption[] => {
  const { formatMessage } = useIntl();
  return useMemo(() => {
    if (!gameData || !gameData.length) return fallback;

    const { handType, hiLo } = JSON.parse(handTypeValue);
    const data = gameData.filter((item) => item.handType === handType && item.hiLo === hiLo);
    const options = [...new Set(data.map((item) => item.potStruct))].map((item) => ({
      text: formatMessage(PotTypeTranslations[item as string]),
      value: item
    }));

    if (!options || !options.length) return fallback;

    return options;
  }, [gameData, handTypeValue, formatMessage]);
};

export default useGetGameType;
